import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { fetchTimeBalances, updateDailyProjectHours } from '../../../redux/slices/timeBalanceSlice';
import TimeBalanceTable from '../TimeBalanceTable/TimeBalanceTable';
import { getTimeLogErrorMessage } from '../../../utils/timeLogging';

const HistoryTab = ({ userId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(); 
  const { items: historyData, isLoading: loading } = useSelector((state) => state.timeBalances);
  
  const [currentDate, setCurrentDate] = useState(new Date());
  const [viewMode, setViewMode] = useState("month");

  const currentYear = currentDate.getFullYear();

  useEffect(() => {
    if (userId) {
      dispatch(fetchTimeBalances({ userId, year: currentYear }));
    }
  }, [dispatch, userId, currentYear]);

  const handleSaveDailyAudit = async (payload) => {
    try {
      await dispatch(updateDailyProjectHours(payload)).unwrap();

      toast.success(t('components.HistoryTab.save_success_toast', 'Registo guardado com sucesso!'));
      dispatch(fetchTimeBalances({ userId: payload.userId, year: currentYear }));

    } catch (err) {
      console.error("Erro no Save:", err);
      toast.error(
        getTimeLogErrorMessage(err, t, t('components.HistoryTab.save_error_toast', 'Erro ao guardar os dados. Tente novamente.')),
      );
    }
  };

  const parseLocalDate = (dateStr) => {
    const [year, month, day] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day);
  };

  const getStartOfWeek = (date) => {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(d.setDate(diff));
  };

  const getDisplayedData = () => {
    if (!historyData) return [];
    return historyData.filter(row => {
      const rowDate = parseLocalDate(row.date);
      if (viewMode === "day") return rowDate.toDateString() === currentDate.toDateString();
      if (viewMode === "week") {
        const start = getStartOfWeek(currentDate);
        const end = new Date(start);
        end.setDate(end.getDate() + 6);
        rowDate.setHours(0, 0, 0, 0);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        return rowDate >= start && rowDate <= end;
      }
      if (viewMode === "month") {
        return rowDate.getFullYear() === currentDate.getFullYear() && 
               rowDate.getMonth() === currentDate.getMonth();
      }
      return true;
    });
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }
  
  return (
    <div className="history-tab-content w-100">
      <TimeBalanceTable 
        historyData={getDisplayedData()}
        currentDate={currentDate}
        userId={userId}
        setCurrentDate={setCurrentDate}
        viewMode={viewMode}
        setViewMode={setViewMode}
        onSaveDailyAudit={handleSaveDailyAudit}
      />
    </div>
  );
};

export default HistoryTab;